import styled from 'styled-components/macro';

/** Set up default heading elements */

export const H1 = styled.h1`
  font-family: ${props => props.theme.fonts.galanoGrotesque};
  margin: 0 0 2rem;
  color: ${({ theme }) => theme.colors.merciless};
  font-size: 2.5em;
  line-height: 1.375;
  font-weight: 600;

  ::selection {
    background: ${({ theme }) => theme.colors.sizzle};
  }
`;

export const H2 = styled.h2`
  font-family: ${props => props.theme.fonts.galanoGrotesque};
  margin: 6rem 0 2rem;
  color: ${({ theme }) => theme.colors.briangerine};
  font-size: 2em;
  line-height: 1.1;
  font-weight: 400;

  span {
    color: ${({ theme }) => theme.colors.darkChocolate};
  }

  ::selection {
    background: ${({ theme }) => theme.colors.sizzle};
  }
`;

export const H3 = styled.h3`
  font-family: ${props => props.theme.fonts.galanoGrotesque};
  /* margin: 0 0 2rem; */
  margin: 0;
  color: ${({ theme }) => theme.colors.merciless};
  font-size: 1.2em;
  line-height: 1.375;
  font-weight: 600;
  text-transform: uppercase;

  ::selection {
    background: ${({ theme }) => theme.colors.sizzle};
  }
`;

export const H4 = styled.h4`
  margin: 0 0 1rem;
  color: ${({ theme }) => theme.colors.merciless};
  font-size: 1em;
  line-height: 1.375;
  font-weight: 700;
  text-transform: uppercase;

  ::selection {
    background: ${({ theme }) => theme.colors.sizzle};
  }
`;

export const H5 = styled.h5`
  margin: 0;
  color: ${({ theme }) => theme.colors.merciless};
  font-size: 1rem;
  line-height: 1.6;
  font-weight: 700;
`;

export const H6 = styled.h6`
  margin: 0;
  color: ${({ theme }) => theme.colors.merciless};
  font-size: 1rem;
  line-height: 1.6;
  font-weight: 400;
  font-style: italic;
`;
